import LazyLoadingList from './LazyLoadingList.component';

export default LazyLoadingList;
